// The coral "P" mark (assets/logos/PM-P-logo.svg), inlined so it inherits size.
import logo from "@/ds/vendor/assets/logos/PM-P-logo.svg";

export function Mark({ size = 32 }: { size?: number }) {
  return <img src={logo} width={size} height={size} alt="PropelMapper" className="pm-mark" />;
}
